var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 1.66666H7.50016C6.39509 1.66666 5.33529 2.10565 4.55388 2.88705C3.77248 3.66845 3.3335 4.72826 3.3335 5.83333V8.33333H0.833496V11.6667H3.3335V18.3333H6.66683V11.6667H9.16683L10.0002 8.33333H6.66683V5.83333C6.66683 5.61232 6.75463 5.40035 6.91091 5.24407C7.06719 5.08779 7.27915 5 7.50016 5H10.0002V1.66666Z",
    stroke: "#97A0AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bc2d2091fa955cbc55573b195255c225.svg";
export { ForwardRef as ReactComponent };